import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { environment } from '../../environments/environment';

export interface DashboardRow {
	[key: string]: any;
	count: number;
}

@Injectable({ providedIn: 'root' })
export class DashboardService {

	private readonly baseUrl = environment.serviceBaseUrl + '/api/dashboard';

	constructor(private http: HttpService) { }

	closedByReason(): Observable<DashboardRow[]> {
		return this.http.get<DashboardRow[]>(this.baseUrl + '/closed-by-reason');
	}

	activeByLawyer(): Observable<DashboardRow[]> {
		return this.http.get<DashboardRow[]>(this.baseUrl + '/active-by-lawyer');
	}

	activeByLawyerPretentsii(): Observable<DashboardRow[]> {
		return this.http.get<DashboardRow[]>(this.baseUrl + '/active-by-lawyer-pretentsii');
	}

	activeByVidSluchaj(): Observable<DashboardRow[]> {
		return this.http.get<DashboardRow[]>(this.baseUrl + '/active-by-vid-sluchaj');
	}

	/** Excel експорт на цялото табло (4 листа). Admin-only. */
	exportExcel(): Observable<HttpResponse<Blob>> {
		return this.http.getBlob(this.baseUrl + '/excel');
	}
}
